module.exports = __webpack_public_path__ + "img/ສະຕິກເກີ້1-7-711x800.0627cab5.jpg";